class IntervalTimer {
  constructor() {
    this.timeMap = {}
    this.id = 0
  }

  /**
   * 添加定时器
   * @param cb {function} 执行任务
   * @param interval {number} 时间间隔
   * @return {number} 定时器id
   */
  addTimer(cb, interval) {
    // 将timeId赋予id
    const timeId = this.id
    // id 自增实现唯一id

    this.id++

    const fn = () => {
      cb()
      this.timeMap[timeId] = setTimeout(() => {
        fn()
      }, interval)
    }

    this.timeMap[timeId] = setTimeout(fn, interval)
    // 返回timeId
    return timeId
  }

  /**
   * 清除定时器
   * @param id {number} 定时器id
   */
  clearTimer(id) {
    clearTimeout(this.timeMap[id])
    this.timeMap[id] = void 0
    delete this.timeMap[id]
  }

  /**
   * 获取当前定时器集合
   * @return {*|Object} 当前定时器集合
   */
  getAllTimers() {
    return this.timeMap
  }

  /**
   * 查询是否有定时器
   * @param id {number} 定时器id
   * @return {boolean} 是否存在
   */
  hasTimer(id) {
    return this.timeMap.hasOwnProperty(id)
  }

  /**
   * 清空所有定时器
   */
  clearAllTimer() {
    for (const key of Object.keys(this.timeMap)) {
      this.clearTimer(this.timeMap[key])
    }
  }
}

export default IntervalTimer
